/**
 * Top products to track for AI insights
 */
export const TOP_PRODUCTS = ['BTC', 'ETH', 'XRP', 'BNB', 'SOL'];

/**
 * Visibility threshold for switching between elements
 */
export const VISIBILITY_THRESHOLD = 50;
